<template>
  <el-container>
    <main class="tab__container">
      <h2 class="page__title">SIP-сервер: {{ sip_server.ip }}</h2>
      <el-tabs ref="tabs">
        <el-tab-pane v-for="(tab, i) in components" :label="tab.name" :key="i">
          <component
            v-loading="loading && tab.name === 'Информация'"
            v-bind="tab.props"
            :is="tab.component"
            :sip_server-id="id"
          />
        </el-tab-pane>
      </el-tabs>
    </main>
  </el-container>
</template>

<script>
import { checkPermission } from "@/core/helpers/permissions";
import { mapActions, mapState } from "vuex";
import SipServerEditTab from "@/components/SipServer/components/tabs/SipServerEditTab";

export default {
  name: "SipServer",
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    const tabs = [
      {
        name: "Информация",
        component: SipServerEditTab,
        permission: "sip_servers:read",
      },
    ];
    return {
      loading: false,
      components: tabs.filter(({ permission }) => checkPermission(permission)),
    };
  },
  computed: {
    ...mapState("sip_server", ["sip_server"]),
  },
  watch: {
    id: {
      immediate: true,
      handler(id, prevId) {
        this.loadSipServer();
        if (prevId) this.$refs.tabs.setCurrentName("0");
      },
    },
  },
  methods: {
    ...mapActions("sip_server", {
      getSipServer: "GET_SIP_SERVER",
    }),
    loadSipServer() {
      this.loading = true;
      this.getSipServer(this.id).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
